module.exports = __webpack_public_path__ + "img/activity_description3.5ea910b6.png";